import useAppStore from "@/context/store";
import { message } from "antd";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { useBannerAds } from "./hooks/useBannerAds";
import { useBannerContent } from "./hooks/useBannerContent";
import { useBannerVisibility } from "./hooks/useBannerVisibility";
import { useGlobalNotice } from "./hooks/useGlobalNotice";
import GlobalBanner from "./index";

const GlobalBannerHeight = 60;

export default function GlobalBannerContainer() {
  const adRef = useRef();
  const router = useRouter();
  const { currentAd } = useBannerAds();
  const { globalNotice, hasNotice } = useGlobalNotice();
  const { visible, onClose, onCloseAds } = useBannerVisibility();
  const { imageSrc, link, color } = useBannerContent(currentAd);
  const setGlobalBannerVisible = useAppStore(
    (state) => state.setGlobalBannerVisible
  );

  const isHomePage = router.pathname === "/";

  useEffect(() => {
    if (isHomePage) {
      setGlobalBannerVisible(false);
    } else {
      setGlobalBannerVisible(!!currentAd || hasNotice);
    }
  }, [currentAd, hasNotice, setGlobalBannerVisible, isHomePage]);

  // 解决adblock的广告屏蔽导致空白一行问题
  useEffect(() => {
    if (adRef.current && visible && !isHomePage) {
      if (adRef.current.offsetHeight === 0) {
        setGlobalBannerVisible(false);
      }
    }
  }, [visible, setGlobalBannerVisible, isHomePage]);

  // 配置 message 位置
  useEffect(() => {
    if (visible && !isHomePage) {
      message.config({
        top: GlobalBannerHeight + 8,
      });
    } else {
      message.config({
        top: 8,
      });
    }
  }, [visible, isHomePage]);

  if (isHomePage) {
    return null;
  }

  return (
    <GlobalBanner
      ref={adRef}
      visible={visible}
      record={currentAd}
      globalNotice={globalNotice}
      onClose={onClose}
      onCloseAds={onCloseAds}
      imageSrc={imageSrc}
      link={link}
      color={color}
    />
  );
}
